import { useNavigate } from 'react-router';
import { DonorDashboardStep } from '@/types/dashboard';
import type { ReactNode } from 'react';
import Label from '@views/register/donor-dashboard-sections/label';

export interface IJourneyStep {
    step: DonorDashboardStep;
    label: ReactNode;
    link: string;
    actionLabel: string;
    isComplete: boolean;
}

interface IProps {
    step: IJourneyStep;
    number: number;
    activeStep: DonorDashboardStep;
    isLiver: boolean;
}

const StepCircle = ({ step, number, activeStep, isLiver }: IProps) => {
    const navigate = useNavigate();

    const isActive = activeStep === step.step;
    const isComplete = !isActive && step.isComplete;

    const state = isActive ? ' journey-step--active' : isComplete ? ' journey-step--complete' : '';

    return (
        <div className={'journey-step' + state}>
            <div className="journey-step__circle">
                {isComplete ? <i className="fas fa-check journey-step__check" aria-hidden="true"></i> : number}
            </div>
            <div className="journey-step__body">
                <Label className="journey-step__label" content={step.label} />
                {isActive && step.link && (
                    <button
                        type="button"
                        className={'journey-step__action' + (isLiver ? ' journey-step__action--liver' : '')}
                        onClick={() => navigate(step.link)}
                    >
                        {step.actionLabel} &rarr;
                    </button>
                )}
            </div>
        </div>
    );
};

export default StepCircle;
